<ng-content select="[sbFormGroupPrefix]"></ng-content>
<div class="not-first-child-children:rounded-l-none not-last-child-children:rounded-r-none relative z-0 flex-auto">
  <ng-content></ng-content>
</div>
<ng-content select="[sbFormGroupSuffix]"></ng-content>
